import { createStyleSheet, GlobalBaseTheme, GlobalThemeInterface, maxContainerWidth, vh } from '@groma-dev/blueprint';

export const getInvitationsStyles = createStyleSheet(
  (theme: GlobalThemeInterface) => ({
    mainContainer: {
      backgroundColor: theme.colors.$background100,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxWidth: '100%',
      minHeight: vh(),
      minWidth: '100%',
      width: '100%',
    },
    mainWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '0 auto',
      maxWidth: `${maxContainerWidth}px`,
      padding: `${theme.spacing.$s8} ${theme.spacing.$s6}`,
      width: '100%',
    },
    contentContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      width: '100%',
      maxWidth: '600px',
      margin: `${theme.spacing.$s6} auto 0px`,
      ...theme.shadows.$shadow100,
      borderRadius: '4px',
      backgroundColor: theme.__base === GlobalBaseTheme.DARK ? theme.colors.$primary400 : theme.colors.$neutral100,
    },
    contentWrapper: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    logo: {
      height: '80px',
    },
    title: {
      ...theme.typography.$textPrimary450,
      width: '100%',
      textAlign: 'left',
      padding: `${theme.spacing.$s5} ${theme.spacing.$s6} ${theme.spacing.$s4}`,
    },
    promptContainer: {
      width: '100%',
      display: 'inline-block',
      textAlign: 'center',
      marginTop: theme.spacing.$s3,
    },
    prompt: {
      ...theme.typography.$textPrimary000,
      display: 'inline-block',
    },
    promptLink: {
      '&.Link-local': {
        display: 'inline-block',
        '& a': {
          color: theme.colors.$interactiveLinkDefault,
          '&:visited': {
            color: theme.colors.$interactiveLinkDefault,
          },
          '&:hover, &:active': {
            color: theme.colors.$interactiveLinkHover,
            '&:visited': {
              color: theme.colors.$interactiveLinkHover,
            },
          },
        },
      },
    },
    [`@media (max-width: ${theme.breakpoints.$sm}px)`]: {
      mainWrapper: {
        padding: `${theme.spacing.$s6} ${theme.spacing.$s3}`,
      },
      logo: {
        height: '60px',
      },
      title: {
        ...theme.typography.$textPrimary350,
        padding: `${theme.spacing.$s4} ${theme.spacing.$s3}`,
      },
    },
  }),
  { name: 'Invitations' }
);
